import { useContext } from 'react';

import { ThemeContext } from '../globalContext/theme/themeProvider';
import { BrandKey } from '../theme/brands/types';

export const BRAND_DISPLAY_NAMES: Record<BrandKey, string> = {
  hale: 'Hale',
  student: 'Sparkl',
};

export const getBrandDisplayName = (brandKey?: BrandKey | null): string =>
  brandKey === 'hale'
    ? BRAND_DISPLAY_NAMES.hale
    : BRAND_DISPLAY_NAMES.student;

export const useBrandDisplayName = (): string => {
  const [themeState] = useContext(ThemeContext);
  return getBrandDisplayName(themeState?.brand?.key);
};
